import { useStore } from 'effector-react'
import { useTranslation } from 'react-i18next'
import { carModel } from '~/entities/common/Car'
import { carEditModel } from '~/features/common/Сars/EditCar'
import { CarStatusEnum } from '~/shared/config/enums'
import { formatDateTimeForUI } from '~/shared/lib/date'
import { Alert } from '~/shared/ui/Alerts'

export function StatusAlert() {
  const { t } = useTranslation()

  const isCarLoading = useStore(carModel.requestFx.pending)

  const car = useStore(carEditModel.$car)

  const lastStatusTransition = car?.getLastStatusTransition()?.getAttributes()
  const responsibleName = car
    ?.getLastStatusTransition()
    ?.getResponsible()
    ?.getName()

  const { createdAt, comment, to, from } = lastStatusTransition || {}

  const responsibleTitle = responsibleName
    ? `${t('alert.status changed by', { responsibleName })}, `
    : ''
  const dateTitle = createdAt
    ? `${t('alert.at datetime', {
        createdAt: formatDateTimeForUI(createdAt),
      })} `
    : ''
  const commentTitle = comment ? t('alert.comment', { comment }) : ''

  const isAutoChangeStatus =
    to === CarStatusEnum.AT_WORK ||
    (from === CarStatusEnum.AT_WORK && to === CarStatusEnum.FREE)

  const title = isAutoChangeStatus
    ? t('alert.automatic status change', { dateTitle })
    : `${responsibleTitle} ${dateTitle} ${commentTitle}`

  if (!lastStatusTransition || isCarLoading) return null

  return (
    <Alert data-testid='car-alert-status-change' variant='info'>
      {title}
    </Alert>
  )
}
